import { Product } from "@/types/types.ts";
import SchemeInformationJson from "./schemeAssets.json";
import { z } from "zod";

export type ProtectPlusScheme = z.infer<typeof scheme>;

const scheme = z.object({
  demandsAndNeedsStatement: z.string().optional(),
  insuranceProductInformationDocument: z.string().optional(),
  schemeHighlight: z.string().optional(),
  schemeMarketingMessage: z.string().optional(),
  termsAndConditions: z.string().optional(),
  whatsCovered: z
    .array(
      z.object({
        coverage: z.string().optional(),
        details: z.array(z.string().optional()).optional(),
      }),
    )
    .optional(),
  whatsNotCovered: z
    .array(
      z.object({
        exclusion: z.string().optional(),
      }),
    )
    .optional(),
});

export function getScheme(product: Product) {
  const sellingProductType = product.sellingProductType;
  if (sellingProductType === "Mobile Phones") {
    return SchemeInformationJson.mobiles;
  } else if (
    sellingProductType === "Ovens" ||
    sellingProductType === "Cookers" ||
    sellingProductType === "Cooker Hoods" ||
    sellingProductType === "Dishwashers" ||
    sellingProductType === "Freezers" ||
    sellingProductType === "Fridge Freezers" ||
    sellingProductType === "Fridges" ||
    sellingProductType === "Tumble Dryers" ||
    sellingProductType === "Washer Dryers" ||
    sellingProductType === "Washing Machines" ||
    sellingProductType === "Hobs" ||
    sellingProductType === "Oven Warming Drawers" ||
    sellingProductType === "Wine Cabinets"
  ) {
    return SchemeInformationJson.appliances;
  }

  let schema = SchemeInformationJson.accidentalDamage;
  product.browsePageHierarchy?.forEach(function (item) {
    if (item.categoryId === "9780211283") {
      schema = SchemeInformationJson.accidentalDamage;
    } else if (item.categoryId === "9780211221") {
      schema = SchemeInformationJson.furniture;
    }
  });

  return schema;
}
